import { createStore, combineReducers } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import resources from './reducers/ResourcesReducer'
import storeReducer from './reducers/StoreReducer'
import form from './reducers/FormReducer'
import authorize from './reducers/AuthorizeReducer'
import stepper from './reducers/StepperReducer'
import innerMenu from './reducers/InnerMenuReducer'
import formValues from './reducers/FormValuesReducer'
import privileges from './reducers/PrivilegeReducer'
import signature from './reducers/SignatureReducer'

const store = createStore(
	combineReducers({
		resources,
		privileges,
		store: storeReducer,
		form,
		authorize,
		innerMenu,
		stepper,
		formValues,
		signature
	}),
	composeWithDevTools()
)

export default store;